import React from 'react';
import ModalContextProvider from '../ModalContext/ModalContext';

const MasterContextProvider = (props) => {
  const { children } = props;
  return (
    <ModalContextProvider>
      { children }
    </ModalContextProvider>
  );
};

export default MasterContextProvider;
